import { render, staticRenderFns } from "./StepCard.vue?vue&type=template&id=fa610976"
import script from "./StepCard.vue?vue&type=script&lang=js"
export * from "./StepCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports